interface BreakpointSize {
  min: number
  max: number
}
type BreakpointsSizes = Record<App.Breakpoint, BreakpointSize>

export const breakpointEntries: Array<[bp: App.Breakpoint, sizes: BreakpointSize]> = [
  ['mobile', { min: 1, max: 575.98 }], // was xxs and xs
  ['tablet', { min: 576, max: 991.98 }], // was sm
  ['desktop', { min: 992, max: 1199.98 }], // was md
  ['largeDesktop', { min: 1200, max: Number.MAX_SAFE_INTEGER }], // was lg and xl
]

export const breakpointSizes = Object.fromEntries(breakpointEntries) as BreakpointsSizes

type MediaQueries = Record<App.Breakpoint, string>
type BreakpointConfig = Partial<Record<App.Breakpoint, Partial<BreakpointSize>>>
export function buildMediaQueryUp(sizes: BreakpointConfig) {
  return Object.entries(sizes).reduce<MediaQueries>((acc, [bp, value]) => {
    if (value.min) {
      acc[bp] = `@media (min-width: ${value.min}px)`
    }
    return acc
  }, {} as MediaQueries)
}

export function buildMediaQueryDown(sizes: BreakpointConfig) {
  return Object.entries(sizes).reduce<MediaQueries>((acc, [bp, value]) => {
    if (value.max) {
      acc[bp] = `@media (max-width: ${value.max}px)`
    }
    return acc
  }, {} as MediaQueries)
}

export function buildMediaQueryOnly(sizes: BreakpointConfig) {
  return Object.entries(sizes).reduce<MediaQueries>((acc, [bp, value]) => {
    if (value.min && value.max) {
      acc[bp] = `@media (min-width: ${value.min}px) and (max-width: ${value.max}px)`
    }
    return acc
  }, {} as MediaQueries)
}

export const mediaQueryUp = buildMediaQueryUp(breakpointSizes)
export const mediaQueryDown = buildMediaQueryDown(breakpointSizes)
export const mediaQueryOnly = buildMediaQueryOnly(breakpointSizes)
